<template>
  <div class="sidebar-logo-container" :class="{ collapse: collapse }">
    <transition name="sidebarLogoFade">
      <router-link v-if="collapse" key="collapse" class="sidebar-logo-link" to="/">
        <img v-if="logoAvailable" :src="logo" class="sidebar-logo" @error="logoAvailable = false">
        <h1 v-else class="sidebar-title sidebar-title-short">SIVA</h1>
      </router-link>
      <router-link v-else key="expand" class="sidebar-logo-link" to="/">
        <img v-if="expandLogoAvailable" :src="logo_expand" class="sidebar-logo-expand" @error="expandLogoAvailable = false">
        <h1 v-else class="sidebar-title">{{ title }}</h1>
      </router-link>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'SidebarLogo',
  props: {
    collapse: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      title: 'Siva Device Manager Admin',
      // logo: 'https://re3.siva-tech.com/siva_logo.png',
      logo: process.env.VUE_APP_STATIC_BASE_URL+'/siva_logo.png',
      // logo_expand: 'https://re3.siva-tech.com/siva_slidebar_logo.png',
      logo_expand: process.env.VUE_APP_STATIC_BASE_URL+'/siva_slidebar_logo.png',
      logoAvailable: true,
      expandLogoAvailable: true
    }
  }
}
</script>

<style lang="scss" scoped>
.sidebarLogoFade-enter-active {
 transition: opacity 1.5s;
}

.sidebarLogoFade-enter,
.sidebarLogoFade-leave-to {
 opacity: 0;
}

.sidebar-logo-container {
 position: relative;
 width: 100%;
 height: 50px;
 line-height: 50px;
 // background: #2b2f3a;
 background: #ffffff;
 text-align: center;
 overflow: hidden;

 & .sidebar-logo-link {
  height: 100%;
  width: 100%;

  & .sidebar-logo-expand {
   width: 160px;
   height: 25px;
   vertical-align: middle;
   margin-right: 12px;
  }

  & .sidebar-logo {
   width: 48px;
   height: 16px;
   vertical-align: middle;
   margin-right: 12px;
  }

  & .sidebar-title {
   display: inline-block;
   margin: 0;
   color: #2f4054;
   font-weight: 600;
   line-height: 50px;
   font-size: 14px;
   font-family: Avenir, Helvetica Neue, Arial, Helvetica, sans-serif;
   vertical-align: middle;
  }

  & .sidebar-title-short {
   font-size: 12px;
  }
 }

 &.collapse {
  .sidebar-logo {
   margin-right: 0px;
  }
 }
}
</style>
